document.addEventListener('DOMContentLoaded', function () {
  const megamenuTriggers = document.querySelectorAll('.has-megamenu');
  const header = document.querySelector('.megamenu-header');
  let currentMegamenu = null;
  let currentTrigger = null;

  // Desktop megamenu
  header.addEventListener('mouseover', loadImages);

  megamenuTriggers.forEach(function (trigger) {
    const menuHandle = trigger.getAttribute('data-menu-handle');
    const megamenu = document.getElementById('megamenu-' + menuHandle);

    if (megamenu) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();

        if (currentMegamenu === megamenu) {
          megamenu.classList.remove('show');
          header.classList.remove('design-white');
          megamenu.classList.remove('design-white');
          currentMegamenu = null;
          currentTrigger = null;
          trigger.classList.remove('open');
          document.removeEventListener('click', closeMegamenuOnOutsideClick);
          document.removeEventListener('keydown', closeMegamenuOnEscape);
        } else {
          document.querySelectorAll('.megamenu').forEach(function (m) {
            m.classList.remove('show');
            m.classList.remove('design-white');
          });

          document.querySelectorAll('.has-megamenu').forEach(function (t) {
            t.classList.remove('open');
          });

          megamenu.classList.add('show');
          trigger.classList.add('open');
          header.classList.add('design-white');
          megamenu.classList.add('design-white');
          currentMegamenu = megamenu;
          currentTrigger = trigger;

          requestAnimationFrame(() => {
            positionMegamenuClass();
          });
          setTimeout(() => {
            document.addEventListener('click', closeMegamenuOnOutsideClick);
            document.addEventListener('keydown', closeMegamenuOnEscape);
          }, 5);
        }
      });
    }
  });

  function loadImages() {
    document.querySelectorAll('.js-megamenu .js-deferredImage, .megamenu .js-deferredImage, .mobile-menu .js-deferredImage').forEach(function (img) {
      img.srcset = img.dataset.deferredSrcset;
      img.src = img.dataset.deferredSrc;
      if (img.complete) {
        img.classList.remove('opacity-0');
      } else {
        img.onload = () => img.classList.remove('opacity-0');
      }
    });

    document.querySelectorAll('.js-megamenu .js-deferredVideo, .megamenu .js-deferredVideo, .mobile-menu .js-deferredVideo').forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.src = video.dataset.src;
      video.load();
    });

    header.removeEventListener('mouseover', loadImages);
  }

  function closeMegamenuOnOutsideClick(e) {
    if (!currentMegamenu) return;

    const isClickInsideMegamenu = currentMegamenu.contains(e.target);
    const isClickOnTrigger = currentTrigger && currentTrigger.contains(e.target);
    const isClickOnLink = e.target.closest('a');

    const clickedOutsideMegamenu = !isClickInsideMegamenu;
    const clickedInsideButNotOnLink = isClickInsideMegamenu && !isClickOnLink;
    const shouldCloseMegamenu = (clickedOutsideMegamenu || clickedInsideButNotOnLink) && !isClickOnTrigger;
    if (shouldCloseMegamenu) {
      currentMegamenu.classList.remove('show');
      currentTrigger.classList.remove('open');
      header.classList.remove('design-white');
      currentMegamenu.classList.remove('design-white');

      document.removeEventListener('click', closeMegamenuOnOutsideClick);
      document.removeEventListener('keydown', closeMegamenuOnEscape);

      currentMegamenu = null;
      currentTrigger = null;
    }
  }

  function closeMegamenuOnEscape(e) {
    if (e.key === 'Escape' && currentMegamenu) {
      currentMegamenu.classList.remove('show');
      currentTrigger.classList.remove('open');
      header.classList.remove('design-white');
      currentMegamenu.classList.remove('design-white');

      document.removeEventListener('click', closeMegamenuOnOutsideClick);
      document.removeEventListener('keydown', closeMegamenuOnEscape);

      currentMegamenu = null;
      currentTrigger = null;
    }
  }

  // Mobile menu
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenuToggleOffButtons = document.querySelectorAll('.mobile-menu-toggle-off');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileMenuMain = document.querySelector('.mobile-menu-main');

  if (mobileMenuToggle && mobileMenu && mobileMenuMain) {
    // Toggle mobile menu
    mobileMenuToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      const isOpen = mobileMenu.classList.contains('open');

      if (isOpen) {
        mobileMenuToggle.classList.remove('active');
        mobileMenu.classList.remove('open');
        header.classList.remove('mobile-menu-active');
        document.body.classList.remove('mobile-menu-open');

        setTimeout(function () {
          mobileMenuMain.classList.remove('slide-left');
          document.querySelectorAll('.mobile-menu-submenu').forEach(function (submenu) {
            submenu.classList.remove('active');
          });
          document.querySelectorAll('.mobile-submenu-item').forEach(function (item) {
            item.classList.remove('active');
          });
        }, 200);
      } else {
        mobileMenuToggle.classList.add('active');
        mobileMenu.classList.add('open');
        header.classList.add('mobile-menu-active');
        document.body.classList.add('mobile-menu-open');
        // Touch devices do not trigger desktop hover, so load deferred assets on open.
        setTimeout(loadImages, 100)
      }
    });

    mobileMenuToggleOffButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        const isOpen = mobileMenu.classList.contains('open');

        if (isOpen) {
          mobileMenuToggle.classList.remove('active');
          mobileMenu.classList.remove('open');
          header.classList.remove('mobile-menu-active');
          document.body.classList.remove('mobile-menu-open');

          setTimeout(function () {
            mobileMenuMain.classList.remove('slide-left');
            document.querySelectorAll('.mobile-menu-submenu').forEach(function (submenu) {
              submenu.classList.remove('active');
            });
            document.querySelectorAll('.mobile-submenu-item').forEach(function (item) {
              item.classList.remove('active');
            });
          }, 200);
        } else {
          mobileMenuToggle.classList.add('active');
          mobileMenu.classList.add('open');
          header.classList.add('mobile-menu-active');
          document.body.classList.add('mobile-menu-open');
        }
      });
    });

    // Click on main link in mobile
    const mainTriggers = document.querySelectorAll('.mobile-menu-trigger.has-submenu');
    mainTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const menuHandle = trigger.getAttribute('data-menu');
        const submenu = document.getElementById('mobile-submenu-' + menuHandle);
        if (submenu) {
          mobileMenuMain.classList.add('slide-left');
          submenu.classList.add('active');
          // Ensure deferred assets are hydrated when entering submenu on mobile.
          loadImages();
        }
      });
    });

    // Back button
    const backButtons = document.querySelectorAll('.mobile-menu-back');
    backButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        mobileMenuMain.classList.remove('slide-left');
        document.querySelectorAll('.mobile-menu-submenu').forEach(function (submenu) {
          submenu.classList.remove('active');
        });
        document.querySelectorAll('.mobile-submenu-item').forEach(function (item) {
          item.classList.remove('active');
        });
      });
    });

    // Accordion in submenu
    const submenuTriggers = document.querySelectorAll('.mobile-submenu-trigger');
    submenuTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const parent = trigger.closest('.mobile-submenu-item');
        const isActive = parent?.classList.contains('active');

        parent?.classList.toggle('active', !isActive);

      });
    });

  }
});

function adjustContentHeight() {
  const container = document.querySelector('.megamenu-section');
  const header = document.querySelector('.megamenu-header');
  const contents = document.querySelectorAll('.megamenu');
  const mobilemenu = document.querySelector('.mobile-menu');
  const announcement = document.getElementById('shopify-section-announcement');
  const mobilemenuheader = document.querySelector('.mobile-menu-header');
  const mobilemenuinner = document.querySelectorAll('.mobile-menu-inner');

  // safety check
  if (!container || !header || !mobilemenu || !contents.length || !mobilemenuheader) return;

  const containerTop = container.getBoundingClientRect().top;
  const headerHeight = header.offsetHeight;
  const announcementHeight = announcement ? announcement.offsetHeight : 0;
  const mobilemenuheaderHeight = mobilemenuheader ? mobilemenuheader.offsetHeight : 0;

  contents.forEach(content => {
    content.style.height = `calc(100vh - ${containerTop + headerHeight}px)`;
  });
  mobilemenu.style.height = `calc(100vh - ${announcementHeight}px)`;
  mobilemenu.style.top = `0px`;

  mobilemenuinner.forEach(mobilemenuinneritem => {
    mobilemenuinneritem.style.height = `calc(100dvh - ${mobilemenuheaderHeight + announcementHeight}px)`;
  });
}

function positionMegamenu() {
  const menus = document.querySelectorAll(".js-megamenu");
  const header = document.querySelector(".megamenu-header");

  if (!header) return;

  const headerRectGlobal = header.getBoundingClientRect();
  const headerTop = header.offsetTop;
  const headerHeight = header.offsetHeight;

  menus.forEach(menu => {
    menu.classList.add("w-screen", "absolute");
    const navParent = menu.closest(".header__nav");
    const megamenuHeader = menu.closest(".megamenu-header");
    const navRectDebug = navParent ? navParent.getBoundingClientRect() : null;

    if (!navParent || !megamenuHeader) return;

    const navOffsetInsideHeader = navRectDebug
      ? navRectDebug.top - headerRectGlobal.top
      : 0;

    const top = headerTop + headerHeight - navOffsetInsideHeader;
    menu.style.top = `${top}px`;

    const navRect = navParent.getBoundingClientRect();

    const leftOffset = navRect.left;

    menu.style.left = `-${leftOffset}px`;

  });
}


function positionMegamenuClass() {
  const menus = document.querySelectorAll('.megamenu');
  const header = document.querySelector('.megamenu-header');
  const section = document.querySelector('.megamenu-section');

  if (!header || !section) return;

  const headerTop = header.offsetTop;
  const headerHeight = header.offsetHeight;

  const top = headerTop + headerHeight + 10;

  menus.forEach(menu => {
    menu.style.top = `${top}px`;
  });
}

if (typeof window !== 'undefined') {
  window.positionMegamenu = positionMegamenu;
  window.positionMegamenuClass = positionMegamenuClass;
}

window.addEventListener('DOMContentLoaded', function () {
  adjustContentHeight();
  positionMegamenuClass();
});

let lastWidth = window.innerWidth;
let lastHeight = window.innerHeight;

window.addEventListener('resize', function () {
  const currentWidth = window.innerWidth;
  const currentHeight = window.innerHeight;

  const widthDiff = Math.abs(currentWidth - lastWidth);
  const heightDiff = Math.abs(currentHeight - lastHeight);

  const RESIZE_THRESHOLD = 20;

  if (widthDiff >= RESIZE_THRESHOLD || heightDiff >= RESIZE_THRESHOLD) {
    adjustContentHeight();
    positionMegamenu();
    positionMegamenuClass();
    lastWidth = currentWidth;
    lastHeight = currentHeight;
  }
});

const SCROLL_THRESHOLD = 800;

window.addEventListener("scroll", function () {
  const scrollPosition = window.scrollY || window.pageYOffset;
  const isNearTop = scrollPosition < SCROLL_THRESHOLD;

  if (isNearTop) {
    adjustContentHeight();
    positionMegamenu();
    positionMegamenuClass();
  }
});

const initializedElements = new WeakSet();
const DRAG_THRESHOLD = 5;

function initSingleElement(scrollContainer) {
  if (initializedElements.has(scrollContainer)) {
    return;
  }

  const width = scrollContainer.offsetWidth;
  const scrollWidth = scrollContainer.scrollWidth;
  const hasOverflow = scrollWidth > width;

  let isDown = false;
  let startX;
  let startY;
  let scrollLeft;
  let hasMoved = false;

  scrollContainer.addEventListener('mousedown', (e) => {
    isDown = true;
    hasMoved = false;
    scrollContainer.style.cursor = 'grabbing';
    scrollContainer.classList.add('is-dragging');
    startX = e.pageX - scrollContainer.offsetLeft;
    startY = e.pageY;
    scrollLeft = scrollContainer.scrollLeft;

    e.preventDefault();
  });

  scrollContainer.addEventListener('mouseleave', () => {
    isDown = false;
    scrollContainer.style.cursor = 'grab';
    scrollContainer.classList.remove('is-dragging');
  });

  scrollContainer.addEventListener('mouseup', () => {
    isDown = false;
    scrollContainer.style.cursor = 'grab';
    scrollContainer.classList.remove('is-dragging');
  });

  scrollContainer.addEventListener('mousemove', (e) => {
    if (!isDown) return;

    const x = e.pageX - scrollContainer.offsetLeft;
    const y = e.pageY;
    const distanceX = Math.abs(x - startX);
    const distanceY = Math.abs(y - startY);

    if (distanceX > DRAG_THRESHOLD || distanceY > DRAG_THRESHOLD) {
      hasMoved = true;
    }

    e.preventDefault();

    const walk = (x - startX) * 2;
    const newScrollLeft = scrollLeft - walk;

    scrollContainer.scrollLeft = newScrollLeft;
  });

  scrollContainer.addEventListener('click', (e) => {
    if (hasMoved) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }, true);

  const links = scrollContainer.querySelectorAll('a');
  links.forEach(link => {
    link.addEventListener('dragstart', (e) => {
      e.preventDefault();
    });
  });

  initializedElements.add(scrollContainer);
}

function checkAndInitElements() {
  const scrollContainers = document.querySelectorAll('.scrollable-products-4-plus');

  scrollContainers.forEach((container, index) => {
    if (!initializedElements.has(container) && container.offsetWidth > 0) {
      initSingleElement(container, index);
    }
  });
}

const observer = new MutationObserver((mutations) => {
  checkAndInitElements();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['class', 'style']
});

document.addEventListener('mouseenter', (e) => {
  if (e?.target?.classList?.contains('scrollable-products-4-plus')) {
    const containers = Array.from(document.querySelectorAll('.scrollable-products-4-plus'));
    const index = containers.indexOf(e.target);
    initSingleElement(e.target, index);
  }
}, true);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    checkAndInitElements();
  });
} else {
  checkAndInitElements();
}

function adjustHeaderOrder() {

  if (window.innerWidth < 1024) {
    return;
  }

  const headerInner = document.querySelector('.megamenu-header-inner');
  const logoPart = document.querySelector('.megamenu-header-leading');
  const megamenuPart = document.querySelector('.megamenu-part');
  const profilePart = document.querySelector('.profile-plus-cart-part');

  if (!headerInner || !logoPart || !megamenuPart || !profilePart) return;

  const logoWidth = logoPart.getBoundingClientRect().width;
  const megamenuWidth = megamenuPart.getBoundingClientRect().width;
  const profileWidth = profilePart.getBoundingClientRect().width;

  const headerInnerRect = headerInner.getBoundingClientRect();
  const headerInnerStyle = window.getComputedStyle(headerInner);
  const paddingLeft = parseFloat(headerInnerStyle.paddingLeft) || 0;
  const paddingRight = parseFloat(headerInnerStyle.paddingRight) || 0;
  const availableWidth = headerInnerRect.width - paddingLeft - paddingRight;

  const gap = parseFloat(window.getComputedStyle(headerInner).gap) || 0;
  const totalGaps = gap * 2;

  const totalNeededWidth = logoWidth + megamenuWidth + profileWidth + totalGaps;

  const needsReorder = totalNeededWidth > availableWidth;

  if (needsReorder) {
    logoPart.style.order = '1';
    profilePart.style.order = '2';
    megamenuPart.style.order = '3';
    megamenuPart.style.width = '100%';
    megamenuPart.style.padding = '12px 0 0 0';
  } else {
    logoPart.style.order = '';
    profilePart.style.order = '';
    megamenuPart.style.order = '';
    megamenuPart.style.width = '';
    megamenuPart.style.padding = '';
  }
}

function callAdjustHeaderOrder() {
  if (window.innerWidth >= 1024) {
    adjustHeaderOrder();
  }
}

window.addEventListener('DOMContentLoaded', callAdjustHeaderOrder);
window.addEventListener('resize', callAdjustHeaderOrder);

const originalPositionMegamenu = positionMegamenu;
positionMegamenu = function () {
  originalPositionMegamenu();
  positionMegamenuClass();
  if (window.innerWidth >= 1024) {
    adjustHeaderOrder();
  }
};
